import { memo } from "react"

const Survey = () => {
  return (
    <>
      Thông tin khảo sát
    </>
  )
}

export default memo(Survey)